import DocMedsConsultationComplete from ".";

export default function DocMedsConsultationCompleteExamples() {
  return <DocMedsConsultationComplete />;
}
